module.exports = __webpack_public_path__ + "e7ebc272595b676203630df5bcb48927.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/lambda-arch.png
// module id = 264
// module chunks = 1